import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-service-dialog',
	templateUrl: './service-dialog.component.html',
	styleUrls: ['./service-dialog.component.scss'],
})
export class ServiceDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<ServiceDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public name: string,
	) {}

	onNoClick(): void {
		this.dialogRef.close();
	}
}
